import React, { useState, useEffect, useMemo } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate, useLocation } from "react-router-dom";
import './growerLleInvoice.css';

import { PRINT_DOWNLOAD_DATA, GET_INVOICE_DATA_BY_INVOICE_NO } from '../../../common/URLs';
import moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { Fab, Typography, Button, Grid, Stack, Divider, CardContent, Card, Container, Box } from '@mui/material';
import apiClient from "../../../axios";

export function LleInvoiceScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const location = useLocation();
  const state = location.state || {};
  
  const invoiceData = state?.selectedRow;
  const invoiceNumber = invoiceData?.invoiceNo ? invoiceData?.invoiceNo : invoiceData?.pitInvoiceNumber; 
  const tabValue = state?.tabValue;
  const pageName = state?.pageName;

  const [lleInvoiceDetails, setlleInvoiceDetails] = useState(null);
  const [downloadinvoice, setDownloadinvoice] = useState(null);

  const goBack = () => {
    if (state?.screen === "invoicePayment" || state?.screen === "invoice" || state?.pageName === "invoicePayment") {
      navigate('/paymentDashboard/invoicePayment', {
        state: { 
          tabValue: state?.tabValue, 
          stakeholderType: state?.stakeholderType,
          openGroupId: state?.openGroupId
        }
      });
    } else if (pageName === "invoiceList") {
      navigate('../invoiceList', { state: { tabValue: tabValue, materialTabValue: state?.materialTabValue } });
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    getInvoiceDetails();
  }, []);

  const getInvoiceDetails = () => {
    let data = {
      invoiceNo: invoiceNumber
    };
    let headers = {
      Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
    };
    apiClient
      .post(GET_INVOICE_DATA_BY_INVOICE_NO, data, { headers })
      .then(res => {
        setlleInvoiceDetails(res.data.invoiceDetails);
      });
  };

  const getDownloadinvoice = (action) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": invoiceNumber,
          "printDetailsType": "lle_invoice"
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadinvoice(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Output.pdf`);
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);

          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }

        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const orderAndShippingRows = useMemo(() => {
    if (!lleInvoiceDetails?.invoiceSourceDestination) return [];
    return lleInvoiceDetails.invoiceSourceDestination.map((item, index) => ({
      ...item,
      id: item.scheduleLineNumber || item.id || `order-${index}`
    }));
  }, [lleInvoiceDetails]);

  const itemRows = useMemo(() => {
    if (!lleInvoiceDetails?.invoiceSourceDestination) return [];
    return lleInvoiceDetails.invoiceSourceDestination.map((item, index) => ({
      ...item,
      customereAddress: lleInvoiceDetails?.customereAddress,
      customerName: lleInvoiceDetails?.customerName,
      id: item.scheduleLineNumber || item.id || `item-${index}`
    }));
  }, [lleInvoiceDetails]);


  const orderColumns = useMemo(() => [
    { field: 'poNo', headerName: t('pit.orderNo'), width: 200 },
    {
      field: 'poDate', headerName: t('pit.orderDate'), width: 130,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
  ], [t]);

  const shippingColumns = useMemo(() => [
    {
      field: 'shippingDate', headerName: t('pit.shippingDate'), width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'shippedByName', headerName: t('pit.shippedByName'), width: 180 },
    { field: 'shippedByPhone', headerName: t('pit.shippedByPhone'), width: 180 },
  ], [t]);

  const columns = useMemo(() => [
    { field: 'scheduleLineNumber', headerName: t('pit.lineNo'), width: 100 },
    {
      field: 'itemCode', headerName: t('pit.itemCode'), width: 100,
      valueGetter: (params) => {
        if (params.row?.materialType === "RawBamboo") {
          return 'RB';
        } else return 'CB';
      }
    },
    { field: 'materialType', headerName: t('pit.ItemDescHSNCode'), width: 200 },
    { field: 'quantity', headerName: t('pit.quantity'), width: 100 },
    { field: 'uom', headerName: t('pit.uom'), width: 100 },
    { field: 'billTo', headerName: t('pit.billTo'), width: 200,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
         {params.row.customerName + ', ' + params.row.customereAddress}
        </div>
      )
     },
    {
      field: 'deliveryDate', headerName: t('pit.deliveryDate'), width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'unitPrice', headerName: t('pit.price'), width: 100 },
    { field: 'unitDesc', headerName: t('pit.unitPer'), width: 100 },
    { field: 'itemType', headerName: t('pit.itemType'), width: 130 },
    { field: 'cgst', headerName: t('pit.cgst'), width: 100 },
    { field: 'sgst', headerName: t('pit.sgst'), width: 100 },
    { field: 'igst', headerName: t('pit.igst'), width: 100 },
    { field: 'tdsTax', headerName: 'TDS Tax (INR)', width: 100 },
    { field: 'invoiceTax', headerName: 'Invoice Tax (INR)', width: 150 },
    { field: 'invoiceAmount', headerName: t('pit.invoiceAmount'), width: 180 },
    { field: 'total', headerName: "Total Invoice Amount (Inc. Taxes) (INR)", width: 220 },
    {
      field: 'netAmountPayable',
      headerName: 'Net Amount Payable (INR)',
      width: 180,
    }
  ], [t]);

  return (
    <Container maxWidth="xxl">
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT36</p>}
      <Typography variant="h4" sx={{ mb: 2 }}>
        <Fab onClick={() => {goBack()}} size="small" aria-label="back" title='Back'>
          <KeyboardArrowLeftRounded />
        </Fab> LLE Invoice
      </Typography>
      <Card>
        <CardContent>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} divider={<Divider orientation="vertical" flexItem />}>
            <Stack direction="column">
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.invoiceNo')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.invoiceNo}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.invoiceDate')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {moment(lleInvoiceDetails?.invoiceDate).format("DD/MM/YYYY")}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.vendorName')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.vendorName}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" sx={{display: "inline", whiteSpace: "nowrap"}} gutterBottom>{t('pit.consignment')}: </Typography>
                <Typography sx={{ display: "inline", whiteSpace: "nowrap" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.consignmentNo}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.invoiceType')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {invoiceData?.invoiceType}
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="column">
              <Typography variant="subtitle1" gutterBottom>{t('pit.vendorDetails')}</Typography>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.name')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.vendorName}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.urn')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.vendorUrn}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>{t('pit.contactPerson')}: </Typography>
                <Typography sx={{ display: "inline", whiteSpace: "nowrap" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.vendorContactName}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>{t('pit.phoneNumber')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.vendorContactNo}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>{t('pit.address')}: </Typography>
                <Typography sx={{ display: "inline", wordBreak: 'break-all' }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.vendorAddress}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.gstIn')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.vendorGSTIN}
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="column">
              <Typography variant="subtitle1" gutterBottom>{t('pit.customerDetails')}</Typography>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.name')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.customerName}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom sx={{display: "inline", whiteSpace: "nowrap"}}>{t('pit.contactPerson')}: </Typography>
                <Typography sx={{ display: "inline", whiteSpace: "nowrap" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.customerContactPerson}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom sx={{display: "inline", whiteSpace: "nowrap"}}>{t('pit.phoneNumber')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.customerContactNo}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.address')}: </Typography>
                <Typography sx={{ display: "inline", wordBreak: 'break-all' }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.customereAddress}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.gstIn')}: </Typography>
                <Typography sx={{ display: "inline" }} variant="body2" ml={1} gutterBottom>
                  {lleInvoiceDetails?.customerGSTIN}
                </Typography>
              </Stack>
            </Stack>
          </Stack>

          <Grid container spacing={1} direction={{ xs: 'column', sm: 'row' }}>
            <Grid item xs={12} md={5} direction="column">
              <Typography sx={{ marginTop: "4vh" }} variant="subtitle1" gutterBottom>{t('pit.orderDetails')}</Typography>
              <DataGrid
                autoHeight
                rows={orderAndShippingRows}
                columns={orderColumns}
                pageSize={10}
                components={{ Toolbar: QuickSearchToolbar }}
              />
            </Grid>
            <Grid item xs={12} md={7} direction="column">
              <Typography sx={{ marginTop: "4vh" }} variant="subtitle1" gutterBottom>{t('pit.shippingDetails')}</Typography>
              <DataGrid
                autoHeight
                rows={orderAndShippingRows}
                columns={shippingColumns}
                pageSize={10}
                components={{ Toolbar: QuickSearchToolbar }}
              />
            </Grid>
          </Grid>

          <DataGrid
            sx={{ marginTop: "4vh" }}
            autoHeight
            getRowHeight={() => 100}
            rows={itemRows}
            columns={columns}
            pageSize={10}
            components={{ Toolbar: QuickSearchToolbar }}
          />
        </CardContent>
      </Card>
      <Box display='flex' justifyContent="flex-end" mt={2}>
        <Button variant="contained" onClick={() => getDownloadinvoice("download")}>{t('pit.download')}</Button>
        <Button variant="contained" sx={{ ml: 2 }} onClick={() => getDownloadinvoice("print")}>{t('pit.print')}</Button>
      </Box>
    </Container>
  );
}

export default LleInvoiceScreen;
